import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "warehouse-form" }
const _hoisted_2 = {
  class: "card",
  style: {"max-width":"980px"}
}
const _hoisted_3 = {
  key: 0,
  class: "item-card item-summary"
}
const _hoisted_4 = { class: "item-photo-wrap" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "item-photo item-photo-empty"
}
const _hoisted_7 = { class: "item-meta" }
const _hoisted_8 = { class: "item-meta" }
const _hoisted_9 = {
  class: "grid",
  style: {"grid-template-columns":"repeat(auto-fit, minmax(220px, 1fr))","gap":"14px"}
}
const _hoisted_10 = { class: "input-field" }
const _hoisted_11 = { class: "input-field" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "input-field" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "input-field" }
const _hoisted_16 = { class: "input-field" }
const _hoisted_17 = ["src"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 1,
  class: "subtitle",
  style: {"color":"#a54b2a"}
}
const _hoisted_20 = { class: "actions" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "form-grid",
        onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitDamage && _ctx.submitDamage(...args)), ["prevent"]))
      }, [
        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "card-header" }, [
          _createElementVNode("div", null, [
            _createElementVNode("h2", {
              class: "title",
              style: {"font-size":"22px"}
            }, "Relatar avaria"),
            _createElementVNode("p", { class: "subtitle" }, "Preencha os dados para abrir o registro de avaria.")
          ])
        ], -1)),
        (_ctx.item)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_ctx.item.photoDataUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "item-photo",
                      src: _ctx.$resolveUrl(_ctx.item.photoDataUrl),
                      alt: "foto item"
                    }, null, 8, _hoisted_5))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, "Sem foto"))
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.item.name), 1),
                _createElementVNode("div", _hoisted_7, "ID: " + _toDisplayString(_ctx.item.code), 1),
                _createElementVNode("div", _hoisted_8, "Categoria: " + _toDisplayString(_ctx.item.category || '-'), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _cache[12] || (_cache[12] = _createElementVNode("label", { for: "damage-summary" }, "Resumo da avaria", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "damage-summary",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.damageSummary) = $event)),
              type: "text"
            }, null, 512), [
              [_vModelText, _ctx.form.damageSummary]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[14] || (_cache[14] = _createElementVNode("label", { for: "damage-project" }, "Projeto", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "damage-project",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.projectId) = $event))
            }, [
              _cache[13] || (_cache[13] = _createElementVNode("option", { value: "" }, "Selecione", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: project.id,
                  value: project.id
                }, _toDisplayString(project.name), 9, _hoisted_12))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.form.projectId]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[16] || (_cache[16] = _createElementVNode("label", { for: "damage-collaborator" }, "Colaborador envolvido", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "damage-collaborator",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.collaboratorUsername) = $event))
            }, [
              _cache[15] || (_cache[15] = _createElementVNode("option", { value: "" }, "Selecione", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collaborators, (user) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: user.username,
                  value: user.username
                }, _toDisplayString(user.name) + " (" + _toDisplayString(user.username) + ") ", 9, _hoisted_14))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.form.collaboratorUsername]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _cache[17] || (_cache[17] = _createElementVNode("label", { for: "damage-details" }, "Descricao detalhada da avaria", -1)),
          _withDirectives(_createElementVNode("textarea", {
            id: "damage-details",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.damageDetails) = $event)),
            rows: "4"
          }, null, 512), [
            [_vModelText, _ctx.form.damageDetails]
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _cache[18] || (_cache[18] = _createElementVNode("label", null, "Fotos da avaria (multiplas)", -1)),
          _createElementVNode("div", {
            class: _normalizeClass(["image-grid", { 'is-drag-over': _ctx.isDragOver }]),
            onDragenter: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.isDragOver = true), ["prevent"])),
            onDragover: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.isDragOver = true), ["prevent"])),
            onDragleave: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.isDragOver = false), ["prevent"])),
            onDrop: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onImagesDropped && _ctx.onImagesDropped(...args)), ["prevent"]))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.photoDataUrls, (img, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `damage-img-${index}`,
                class: "image-preview"
              }, [
                _createElementVNode("img", {
                  src: _ctx.resolveUrl(img),
                  alt: "preview avaria"
                }, null, 8, _hoisted_17),
                _createElementVNode("button", {
                  class: "image-remove",
                  type: "button",
                  onClick: ($event: any) => (_ctx.removeImage(index))
                }, "x", 8, _hoisted_18)
              ]))
            }), 128)),
            _createElementVNode("button", {
              class: "image-add",
              type: "button",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.triggerImageInput && _ctx.triggerImageInput(...args)))
            }, "+")
          ], 34),
          _createElementVNode("input", {
            id: "damage-file-input",
            class: "hidden-input",
            type: "file",
            accept: "image/*",
            multiple: "",
            onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onImagesSelected && _ctx.onImagesSelected(...args)))
          }, null, 32)
        ]),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.error), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "submit",
            disabled: _ctx.saving
          }, _toDisplayString(_ctx.saving ? 'Salvando...' : 'Salvar avaria'), 9, _hoisted_21),
          _createElementVNode("button", {
            class: "btn btn-ghost",
            type: "button",
            disabled: _ctx.saving,
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
          }, "Cancelar", 8, _hoisted_22)
        ])
      ], 32)
    ])
  ]))
}